// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-NotFound-__style___V7akg","btn-back":"app-pages-NotFound-__style___1r53-","pageNotFound":"app-pages-NotFound-__style___17TbJ","textNotFound":"app-pages-NotFound-__style___2fvdH"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/NotFound/style.css
// module id = 2465
// module chunks = 0